import React, { useEffect } from 'react'
import { BodyText, InvestmentColTwoSpanReverse, LeftColSection, RightColSection } from '../investment/Investment.styles'
import { LeftSection, RightSection, SavingsHeader, SavingsWrapper } from '../savingsStage/SavingsStage.styles'

export const GroupTargetSavings = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <SavingsWrapper>
         <SavingsHeader>
            <LeftSection>
            <h3>
                Group target savings 
                Optimally designed to enable an effective collective Savings
            </h3>
            </LeftSection>
            <RightSection>
                <img src="img/Frame (1).svg" alt="Group of people playing dart game" />
            </RightSection>
        </SavingsHeader>
        <InvestmentColTwoSpanReverse>
        <LeftColSection>
          <BodyText>
                This plan enables group of people save towards a mutual goal among friends, family,
                co-worker, colleagues, e.t.c everyone who wants to save together for the common benefit.


          </BodyText>
        </LeftColSection>
        <RightColSection>
            <img src="img/Frame (2).svg" alt="humaan hands carrying a bag of money" />
        </RightColSection>
      </InvestmentColTwoSpanReverse>
    </SavingsWrapper>

  )
}
